import RestAPI from '../../../components/Common/restApi';

export default class DeviceApi {
  static persistBrowserToken(token) {
    return RestAPI.updateWithFormData('/alpha/pro/devices/browser', { token: token });
  }
}
